import React from "react";
import commonService from "../../../services/common-service";

const Summary = ({ label, value, symbol, className='' }) => (
  <div className={`price-row ${className}`}>
    <span className="label">{label}</span>
    <span className="val">
      {symbol}
      {` `}
      {value}
    </span>
  </div>
);
const CheckoutSummary = ({
  subTotal,
  discount,
  couponDiscount,
  totalDiscount,
  total,
  symbol,
  rate,
  currency,
  shippingCharge,
}) => {
  return (
    <div className="pricing-breakdown">
      <Summary
        label="Sub total"
        value={commonService.getConvertedPrice(subTotal, rate, currency)}
        symbol={symbol}
      />

      {discount !== null && discount > 0 && (
        <Summary
          label="Discount"
          value={commonService.getConvertedPrice(discount, rate, currency)}
          symbol={symbol}
        />
      )}
      {couponDiscount !== null && couponDiscount > 0 && (
        <Summary
          label="Coupon discount"
          value={commonService.getConvertedPrice(
            couponDiscount,
            rate,
            currency,
          )}
          symbol={symbol}
        />
      )}
      {discount !== null &&
        discount > 0 &&
        couponDiscount !== null &&
        couponDiscount > 0 && (
          <Summary
            label="Total discount"
            value={commonService.getConvertedPrice(
              totalDiscount,
              rate,
              currency,
            )}
            symbol={symbol}
          />
        )}

      <div className="price-row">
        <span className="label">Shipping Charge</span>

        <span className="val">
          {shippingCharge !== null && shippingCharge > 0 ? (
            <>
              {symbol}
              {` `}
              {commonService.getConvertedPrice(shippingCharge, rate, currency)}
            </>
          ) : (
            "Free Shipping"
          )}
        </span>
      </div>

      <Summary
        label="Total"
        value={commonService.getConvertedPrice(total, rate, currency)}
        symbol={symbol}
        className="total"
      />
    </div>
  );
};

export default CheckoutSummary;



